function initScreensaver() {
  const logo = document.querySelector('[data-screensaver-logo]')
  if (!logo) return

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  const placeCentered = () => {
    logo.style.left = '50%'
    logo.style.top = '50%'
    logo.style.transform = 'translate(-50%, -50%)'
  }

  if (reducedMotion.matches) {
    placeCentered()
    return
  }

  const speed = 2.2
  let x = 0
  let y = 0
  let vx = speed * (Math.random() > 0.5 ? 1 : -1)
  let vy = speed * (Math.random() > 0.5 ? 1 : -1)
  let frame = 0

  const size = () => ({
    w: logo.offsetWidth,
    h: logo.offsetHeight,
    maxX: Math.max(0, window.innerWidth - logo.offsetWidth),
    maxY: Math.max(0, window.innerHeight - logo.offsetHeight)
  })

  logo.style.left = '0'
  logo.style.top = '0'

  const tick = () => {
    const { w, h, maxX, maxY } = size()
    if (!w || !h) {
      frame = requestAnimationFrame(tick)
      return
    }

    x += vx
    y += vy

    if (x <= 0) {
      x = 0
      vx = Math.abs(vx)
    } else if (x >= maxX) {
      x = maxX
      vx = -Math.abs(vx)
    }

    if (y <= 0) {
      y = 0
      vy = Math.abs(vy)
    } else if (y >= maxY) {
      y = maxY
      vy = -Math.abs(vy)
    }

    logo.style.transform = `translate(${x}px, ${y}px)`
    frame = requestAnimationFrame(tick)
  }

  const boot = () => {
    const { w, h, maxX, maxY } = size()
    if (!w || !h) {
      frame = requestAnimationFrame(boot)
      return
    }

    x = 24 + Math.random() * Math.max(1, maxX - 24)
    y = 24 + Math.random() * Math.max(1, maxY - 24)
    tick()
  }

  const onResize = () => {
    const { maxX, maxY } = size()
    x = Math.min(x, maxX)
    y = Math.min(y, maxY)
  }

  window.addEventListener('resize', onResize)
  frame = requestAnimationFrame(boot)

  reducedMotion.addEventListener('change', (event) => {
    if (!event.matches) return
    cancelAnimationFrame(frame)
    window.removeEventListener('resize', onResize)
    placeCentered()
  })
}

document.addEventListener('DOMContentLoaded', initScreensaver)
